import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const TmetricSettingsActions = {
  createTmetricSettings: async ({ dispatch, commit }, value) => {
    commit('setTmetricSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'tmetric',
        value,
      }).
      then(({ data }) => {
        commit('setTmetricEnableDetails', false)
        commit('setTmetricSettings', data)
        dispatch('getTmetricWorkspaces')

        return data
      }).
      catch(handleError).
      finally(_ => commit('setTmetricSettingsLoading', false))
  },

  getTmetricSettings: async ({ commit, dispatch }) => {
    commit('setTmetricSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/tmetric').
      then(({ data }) => {
        commit('setTmetricEnableDetails', false)
        commit('setTmetricSettings', data)
        dispatch('getTmetricWorkspaces')

        return data
      }).
      catch(handleError).
      finally(_ => commit('setTmetricSettingsLoading', false))
  },

  updateTmetricSettings: async ({ dispatch, getters, commit }, value) => {
    commit('setTmetricSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.tmetricSettings.id}`, {
        name: 'tmetric',
        value,
      }).
      then(({ data }) => {
        commit('setTmetricEnableDetails', false)
        commit('setTmetricSettings', data)
        dispatch('getTmetricWorkspaces')

        return data
      }).
      catch(handleError).
      finally(_ => commit('setTmetricSettingsLoading', false))
  },

  deleteTmetricSettings: async ({ dispatch, getters, commit }) => {
    commit('setTmetricSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.tmetricSettings.id}`).
      then(({ data }) => {
        commit('setTmetricEnableDetails', false)
        commit('setTmetricSettings', data)
        dispatch('getTmetricWorkspaces')

        return data
      }).
      catch(handleError).
      finally(_ => commit('setTmetricSettingsLoading', false))
  },

  // eslint-disable-next-line camelcase
  getTmetricWorkspaces: async ({ commit, getters }, settings) => {
    const apiKey = settings?.tmetric_api_key || getters.tmetricSettingsValue?.tmetric_api_key
    if (!apiKey) return commit('setTmetricWorkspaces', [])

    return axiosRequest.
      get('/admin/tmetric/workspaces', { params: { tmetric_api_key: apiKey } }).
      then(({ data }) => commit('setTmetricWorkspaces', data.data)).
      catch(handleError)
  },

  pingTmetric: async ({ commit }, apiKey) => {
    commit('setTmetricSettingsLoading', true)
    commit('setTmetricAPIKeyValid', null)

    return axiosRequest.
      get('/tmetric/ping', { params: { tmetric_api_key: apiKey } }).
      then(({ data }) => {
        commit('setTmetricAPIKeyValid', data.api_key_validated === true)
        return data.api_key_validated === true
      }).
      catch(handleError).
      finally(_ => commit('setTmetricSettingsLoading', false))
  },

  setExpirationDate: ({ commit }, date) => commit('setTmetricExpirationDate', date),
  setTmetricEnableDetails: ({ commit }, value) => commit('setTmetricEnableDetails', value),
}
